<template>
  <div>
    <modal name="unsubscribe-all"
           class="vue-dialog modal-unsubscribe-all"
           height="auto"
           width="450"
           :clickToClose="!wordingsEditable"
           @opened="$emit('open');">
      <div class="dialog-content">
        <div class="dialog-c-title"
             v-word:layout.userProfile.mailing.unsubscribeModal.header></div>
        <div v-if="loading">
          <div class="dialog-c-text"
               v-word:layout.userProfile.mailing.unsubscribeModal.text></div>
        </div>
        <div v-if="!loading"
             class="loading-spinner-image"></div>
        <div v-if="wordingsEditable"
             @click.prevent="close"
             class="modal-dialog-close"
             title="Close dialog"></div>
      </div>
      <div class="vue-dialog-buttons">
        <button type="button"
                class="vue-dialog-button btn-unsubscribe"
                @click.prevent="unsubscribe"
                v-word:layout.userProfile.mailing.unsubscribeModal.btnOk>
        </button>
        <button type="button"
                class="vue-dialog-button"
                @click.prevent="close"
                v-word:layout.userProfile.mailing.unsubscribeModal.btnCancel>
        </button>
      </div>
    </modal>
  </div>
</template>

<script>
import config from 'config';
import * as mixins from '../../mixins';
import backendConfig from '../../utils/backendConfig';

export default {
  mixins: [mixins.wordedPage],
  props: ['store'],
  data() {
    return {
      loading: true,
    };
  },
  methods: {
    open() {
      this.$modal.show('unsubscribe-all');
    },
    close() {
      this.$modal.hide('unsubscribe-all');
    },
    unsubscribe() {
      backendConfig.get().then(({backendUrl}) => {
        const url =
          backendUrl + config.backend.feeds.unsubscribeMailingLists +
          '?sso=' +
          this.store.brokerData;

        this.$emit('loading');
        this.$http
          .get(url)
          .then(() => {
            this.close();
            this.$emit('loaded');
            this.$emit('unsubscribe');
            this.flash(
              '' +
                this.wordings[
                  'layout.userProfile.mailing.unsubscribeModal.success'
                ],
              'success',
            );
          })
          .catch(() => {
            this.close();
            this.$emit('loaded');
            this.flash(
              '' +
                this.wordings[
                  'layout.userProfile.mailing.unsubscribeModal.error'
                ],
              'error',
            );
          });
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/user-profile/UnsubscribeModal.vue